// extracted by mini-css-extract-plugin
export var center = "_4m-2";
export var clickableRow = "_4m-5";
export var expandedRow = "_4m-7";
export var hoverable = "_4m-4";
export var left = "_4m-1";
export var right = "_4m-3";
export var row = "_4m-0";
export var selectedRow = "_4m-6";
export var summaryRow = "_4m-8";